import * as React from "react";
import { cn } from "@/lib/utils";

export interface TextProps extends React.HTMLAttributes<HTMLDivElement> {
  as?: React.ElementType;
  asChild?: boolean;
  htmlFor?: string;
  numberOfLines?: never;
  /** Native only (the phone's text size); taken out so it doesn't reach the DOM */
  maxFontSizeMultiplier?: number;
}

export const Text = React.forwardRef<HTMLDivElement, TextProps>(
  (
    {
      htmlFor,
      as: Element = htmlFor ? "label" : "p",
      asChild: _asChild,
      numberOfLines,
      maxFontSizeMultiplier: _maxFontSizeMultiplier,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <Element
        {...props}
        className={cn(className, numberOfLines && "line-clamp-[var(--lineClamp)]", "font-inter")}
        ref={ref}
        htmlFor={htmlFor}
        style={{
          "--lineClamp": numberOfLines,
        }}
      />
    );
  },
);
